import { Routes } from "@angular/router";

export const content: Routes = [
    {
        path: 'superadmin',
        data: {
            title: "Superadmin",
            breadcrumb: "",

        },
        loadChildren: () => import('../../superadmin/superadmin.routes'),
    },
   
]


